import { useUserContext } from "@context/UserContext";
import { formateCpf, formatPhone } from "@hooks/masks";
import { createZendeskUser, getCurrentTicketNumber, getCustomObjects, zafClient } from "@services/Zendesk";
import { useNavigate } from "react-router-dom";

export function useReviewUserAccountUser() {
  const {
    newUserFormData,
    selectedRole,
    urlCustom,
    setUrlCustom,
    setSelectedUser
  } = useUserContext();
  const navigate = useNavigate();
  const documentLabel = newUserFormData?.cpf_3 ? 'CPF' : 'Documento';
  const documentValue = formateCpf(newUserFormData?.cpf_3) || '—';
  const phoneValue = formatPhone(newUserFormData?.phone) || '—';

  const info = [
    { label: "Nome", value: newUserFormData?.name },
    { label: documentLabel, value: documentValue },
    { label: "Email", value: newUserFormData?.email },
    { label: "Telefone", value: phoneValue },
    ...(selectedRole ? [{ label: "Conta", value: selectedRole }] : [])
  ];

  const handleSave = async () => {
    try {
      const response = await createZendeskUser(zafClient, {
        name: newUserFormData.name,
        email: newUserFormData.email,
        phone: newUserFormData.phone,
        user_fields: { cpf_3: newUserFormData.cpf_3.replace(/\D/g, '') }
      });

      const createdUser = response;
      setSelectedUser(createdUser);

      if (selectedRole) {
        const ticket = await getCurrentTicketNumber(zafClient);
        const customObjects = await getCustomObjects(zafClient, ticket as number);

        let customObject = customObjects.find((obj: { external_id: string }) =>
          obj.external_id === `ticket-${ticket}`
        );

        if (customObject) {
          const updatedFields = {
            ...customObject.custom_object_fields,
            [selectedRole]: createdUser.id
          };

          await zafClient.request({
            url: customObject.url,
            type: "PUT",
            data: {
              custom_object_record: {
                custom_object_fields: updatedFields
              }
            }
          });
        } else {
          const response = await zafClient.request({
            url: `/api/v2/custom_objects/contas_do_ticket/records/${customObjects[0].id}`,
            type: "PUT",
            data: {
              custom_object_record: {
                custom_object_id: customObjects[0].id,
                custom_object_fields: {
                  [selectedRole]: createdUser.id
                }
              }
            }
          });

        const customObjectsType = response as {
          custom_object_record: {
            [key: string]: string
          };
        };
          customObject = customObjectsType.custom_object_record;


          if (customObject.url && !urlCustom.includes(customObject.url)) {
            setUrlCustom([...urlCustom, customObject.url]);
          }
        }
      }
      navigate("/user-success-account", {
        state: { userId: createdUser.id } 
      });

    } catch (error) {
      console.error("Error saving user account:", error);
      throw error;
    }
  };

  return {
    newUserFormData,
    info,
    navigate,
    handleSave,
  };
}